import { Component, Input } from '@angular/core';
import { BasicPageLayoutOptions } from './BasicPageLayoutOptions';

@Component({
    selector: 'gradient-page-header',
    template: `
        <div
            class="bg-color-gradient-blue"
            style="padding: 20px; height: 110px;"
        >
            <ng-content select="[page-header-gradient]"></ng-content>
        </div>
        <div style="background: white; padding: 20px 0 15px 0">
            <div
                class="widthLimitedLayout--md"
                [ngClass]="{
                    'widthLimitedLayout--enhanced': options.enhancedSize
                }"
            >
                <ng-content select="[page-header-white]"></ng-content>
            </div>
        </div>
    `,
    standalone: false
})
export class GradientHeaderComponent {
    @Input()
    options: BasicPageLayoutOptions = {};
}
